<template>
  <div
    class="ticket-page-wrapper fullscreen-fixed print-no-hidden"
    :style="{
      backgroundColor: $store.registratorBackgroundColor,
      backgroundImage: `url(${$store.mobileBackgroundImage})`,
      'justify-content': $store.isNoPrintTicket || isQrDevice ? 'center' : 'flex-end'
    }"
    :class="{ 'qr-code-device': isQrDevice }"
  >
    <div v-if="$store.isNoPrintTicket" class="no-print-ticket">
      <p
        class="ticket-page__title"
        :style="{ color: $store.registratorCaptionColor }"
      >
        {{ 'record_complete' | translate }}
        <br />
        <br />
        {{ 'record_remember' | translate }}
      </p>
    </div>
    <div v-else>
      <p
        class="ticket-page__title"
        :style="{ color: $store.registratorCaptionColor }"
      >
        {{ 'registrator_dont_forget_ticket' | translate }}!
        <br />
        {{ 'registrator_thanks' | translate }}!
      </p>
    </div>
    <Ticket
      class="ticket-page__ticket print-no-hidden"
      :ticket="ticket"
      @ticketReady="ticketReady"
    />
    <Arrow
      v-if="!isQrDevice && !$store.isNoPrintTicket"
      class="ticket-page__arrow"
      :direction="'down'"
      :style="{ fill: $store.registratorCaptionColor }"
    />
  </div>
</template>

<script>
import Ticket from './Ticket';
import Arrow from './Icons/Arrow';
import { DEVICE_TYPES } from '../config';

export default {
  name: 'TicketPage',
  components: {
    Ticket,
    Arrow,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    deviceType: {
      type: String,
      required: true,
    },
  },
  computed: {
    isQrDevice() {
      return this.deviceType === DEVICE_TYPES.QR_CODE;
    },
  },
  methods: {
    ticketReady(data) {
      this.$emit('ticketReady', data);
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-page-wrapper {
  z-index: 5;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  &.qr-code-device {
    justify-content: center;
    .ticket-page__title {
      display: none;
    }
  }
}

.ticket-page {
  &__title {
    font-size: min(3.75vw, 3.75vh, 30px);
    font-weight: 600;
  }

  &__title,
  &__ticket {
    margin-bottom: min(3.515625vh, 36px);
  }

  &__arrow {
    min-width: 46px;
    height: auto;
    margin-bottom: min(2.59259259vh, 28px);
  }
}
.no-print-ticket {
  max-width: 380px;
  line-height: 38px;
}
</style>

<!-- <template>
  <div
    class="ticket-page-wrapper fullscreen-fixed print-no-hidden"
    :style="{ backgroundColor: $store.registratorBackgroundColor, backgroundImage: `url(${$store.mobileBackgroundImage})` }"
    :class="{'qr-code-device': isQrDevice}"
  >
    <p
      class="ticket-page__title"
      :style="{ color: $store.registratorCaptionColor }"
    >
      Вы записаны!<br><br>Пожалуйста, запомните
      <br>номер вашей очереди.
    </p>
    <Ticket
      class="ticket-page__ticket print-no-hidden"
      :ticket="ticket"
      @ticketReady="ticketReady()"
    />
  </div>
</template>

<script>
import Ticket from './Ticket';
import Arrow from './Icons/Arrow';
import {DEVICE_TYPES} from "../config";

export default {
  name: 'TicketPage',
  components: {
    Ticket,
    Arrow
  },
  props: {
    ticket: {
      type: Object,
      required: true
    },
    deviceType: {
      type: String,
      required:true
    }
  },
  computed: {
    isQrDevice() {
      return this.deviceType === DEVICE_TYPES.QR_CODE
    }
  },
  methods: {
    ticketReady() {
      this.$emit('ticketReady');
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-page-wrapper {
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  &.qr-code-device {
    justify-content: center;
    .ticket-page__title {
      display: none;
    }
  }
}

.ticket-page {
  &__title {
    font-size: min(3.95vw, 3.95vh, 32px);
    font-weight: 600;
  }

  &__title,
  &__ticket {
    margin-bottom: min(3.515625vh, 36px);
  }

  &__arrow {
    min-width: 46px;
    height: auto;
    margin-bottom: min(2.59259259vh, 28px);
  }

}
</style> -->
